import axios from 'axios';
import logo from '@/assets/logo.png'
import title from '@/assets/title.png'
import { ethers } from 'ethers';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import zd from '@/assets/zd.png'
import model from '@/assets/model.png'
import bgcircle from '@/assets/bgcircle.png'
import left from '@/assets/left.png'
import right from '@/assets/right.png'
import three from '@/assets/three.png'
import bottom from '@/assets/bottom.png'
import xlogo from '@/assets/xlogo.png';
import que from '@/assets/que.png';
import { SlotMachine } from '@lucky-canvas/react'
import { useState, useRef, useEffect } from 'react'
import banner1 from '@/assets/banner/1.png'
import banner2 from '@/assets/banner/2.png'
import banner3 from '@/assets/banner/3.png'
import banner4 from '@/assets/banner/4.png'
import banner5 from '@/assets/banner/5.png'
import banner6 from '@/assets/banner/6.png'
import pro1 from '@/assets/profile/1.png'
import pro2 from '@/assets/profile/2.png'
import pro3 from '@/assets/profile/3.png'
import pro4 from '@/assets/profile/4.png'
import pro5 from '@/assets/profile/5.png'
import pro6 from '@/assets/profile/6.png'
import pro7 from '@/assets/profile/7.png'
import pro8 from '@/assets/profile/8.png'
import pro9 from '@/assets/profile/9.png'
import pro10 from '@/assets/profile/10.png'
import pro11 from '@/assets/profile/11.png'
import pro12 from '@/assets/profile/12.png'
import pro13 from '@/assets/profile/13.png'
import pro14 from '@/assets/profile/14.png'
import TypewriterText from '@/components/TypewriterText.jsx'
import "./aya.css"
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
function Aaya() {
    const [showSlotMachine, setShowSlotMachine] = useState(false);
    const [showTitle, setShowTitle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lotteryFinished, setLotteryFinished] = useState(false);
    const [walletAddress, setWalletAddress] = useState('');
    const [message, setMessage] = useState('');
    const [selectedChar, setSelectedChar] = useState(null);
    const [transactionData, setTransactionData] = useState([]);
    const myLucky = useRef()
    const containerRef = useRef(null);
    const [prizes] = useState([
        { imgs: [{ src: pro1, width: 168, height: 168 }] },
        { imgs: [{ src: pro2, width: 168, height: 168 }] },
        { imgs: [{ src: pro3, width: 168, height: 168 }] },
        { imgs: [{ src: pro4, width: 168, height: 168 }] },
        { imgs: [{ src: pro5, width: 168, height: 168 }] },
        { imgs: [{ src: pro6, width: 168, height: 168 }] },
        { imgs: [{ src: pro7, width: 168, height: 168 }] },
        { imgs: [{ src: pro8, width: 168, height: 168 }] },
        { imgs: [{ src: pro9, width: 168, height: 168 }] },
        { imgs: [{ src: pro10, width: 168, height: 168 }] },
        { imgs: [{ src: pro11, width: 168, height: 168 }] },
        { imgs: [{ src: pro12, width: 168, height: 168 }] },
        { imgs: [{ src: pro13, width: 168, height: 168 }] },
        { imgs: [{ src: pro14, width: 168, height: 168 }] },
    ])

    const [charDesc] = useState([
        { src: pro1, name: 'CZ', desc: 'Steering the Binance battleship through every market storm. The crypto seas obey his compass.', title: 'The Icon of Web3' },
        { src: pro2, name: 'Donald Trump', desc: `U.S. President, a 'tempest' on X, whose words can stir up storms in the crypto market.`, title: 'The Tweet-to-Rule President' },
        { src: pro3, name: 'Elon Musk', desc: 'His memes move markets. Tweet fingers control the crypto weather.', title: 'CEO of Doge Universe' },
        { src: pro4, name: 'Sam Altman', desc: 'Feeding GPTs with data while scanning your iris. The future is a Sam Altman simulation.', title: ' Iris Harvester' },
        {
            src: pro5, name: 'Vitalik Buterin', desc: `The man who codes in Solidity like it's Elvish.Accidentally summoned the Ethereum multiverse.`, title: 'King of Consensus'
        },
        { src: pro6, name: 'Satoshi Nakamoto', desc: 'Invented Bitcoin, disappeared, left the world searching on-chain.', title: 'Origin with No Face' },
        { src: pro7, name: 'Yi He', desc: 'Marketing wizard. Speaks human, thinks in growth metrics.', title: 'Iron Priestess of Binance' },
        { src: pro8, name: 'Snoop Dogg', desc: 'Smoked into Web3, dropped beats and NFTs. The vibe is always on-chain.', title: 'Metaverse Rapper' },
        { src: pro9, name: 'Justin Sun', desc: 'Can connect with anyone. Except the SEC.', title: 'Networking King' },
        {
            src: pro10, name: 'Stephen Curry', desc: `My three-point arc is the heartbeat of every degen's portfolio. 🐵📈`, title: 'NFT Sharpshooter'
        },
        { src: pro11, name: 'Cristiano Ronaldo', desc: 'SIUUU—every celebration now means the chart just pumped.', title: 'On-chain Scorer' },
        { src: pro12, name: 'はたの ゆい', desc: `What fills your hard drive shouldn't be just me — but crypto, too.`, title: 'Dream of a Thousand Boys' },
        { src: pro13, name: 'HongKongDoll', desc: 'Every one of my videos is a censored tribute to Web3 values.', title: 'Decentralized Barbie' },
        { src: pro14, name: ' Pepe', desc: `When I cry, it's not sorrow. It's my wallet burning.`, title: 'Abstract Player' },

    ])
    const socialInfluences = [
        { id: 1, date: "2025-03-29 14:43", address: "0Xhjfkshbfjkd45566hjfhdsjvd", text: "This paragraph of text This paragraph of text、This paragraph of text This paragraph of text、This paragraph of text This paragraph of text" },
        { id: 2, date: "2025-03-29 15:00", address: "0Xabcd1234efgh5678ijkl9012", text: "This paragraph of text This paragraph of text、This paragraph of text This paragraph of text、This paragraph of text This paragraph of text" },
        { id: 3, date: "2025-03-30 10:20", address: "0Xmnop3456qrst7890uvwx1234", text: "This paragraph of text This paragraph of text、This paragraph of text This paragraph of text、This paragraph of text This paragraph of text" },
        { id: 4, date: "2025-03-29 14:43", address: "0Xhjfkshbfjkd45566hjfhdsjvd", text: "This paragraph of text This paragraph of text、This paragraph of text This paragraph of text、This paragraph of text This paragraph of text" },
        { id: 5, date: "2025-03-29 15:00", address: "0Xabcd1234efgh5678ijkl9012", text: "This paragraph of text This paragraph of text、This paragraph of text This paragraph of text、This paragraph of text This paragraph of text" },
        { id: 6, date: "2025-03-30 10:20", address: "0Xmnop3456qrst7890uvwx1234", text: "This paragraph of text This paragraph of text、This paragraph of text This paragraph of text、This paragraph of text This paragraph of text" }
    ];
    const [slots] = useState([
        {
            order: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            speed: 20,
            direction: 1
        }
    ])
    const startLottery = async () => {
        console.log(transactionData, 'transactionDatatransactionData');
        console.log(getNumberFromString(walletAddress));
        if (loading) return;
        setLoading(true);
        setLotteryFinished(false);
        try {
            if (walletAddress) {
                const response = await axios.get(`https://deep-index.moralis.io/api/v2.2/wallets/${walletAddress}/history?chain=bsc&order=DESC`, {
                    headers: {
                        'accept': 'application/json',
                        'X-API-Key': import.meta.env.VITE_KEY
                    }
                });
                setTransactionData(response.data.result);
                if (showSlotMachine) {
                    const index = getNumberFromString(walletAddress);
                    if (index >= 0 && index < charDesc.length) {
                        setSelectedChar(charDesc[index]);
                    }
                    setShowTitle(false);
                    myLucky.current.play();
                    setTimeout(() => {
                        myLucky.current.stop(index);
                    }, 2500);
                } else {
                    setShowSlotMachine(true);
                }

            } else {
                setMessage('Wallet address is empty!');
                setLoading(false);
            }

        } catch (err) {
            console.error(err.response.data.message);
            setMessage(err.response.data.message);
            setLoading(false);
        }
    };

    const getNumberFromString = (str) => {
        let numbers = str.replace(/\D/g, '');
        if (!numbers) return 0;
        let sum = BigInt(numbers);

        return Number(sum % 15n);
    };


    useEffect(() => {
        const index = getNumberFromString(walletAddress);
        if (index >= 0 && index < charDesc.length) {
            setSelectedChar(charDesc[index]);
        }
        if (showSlotMachine) {
            myLucky.current.play();
            setTimeout(() => {
                myLucky.current.stop(index);
            }, 2500);
        }
    }, [showSlotMachine]);

    const endLottery = (prize) => {
        console.log(prize);
        console.log(selectedChar, '1212');
        setShowTitle(true);
        setLoading(false);
        setLotteryFinished(true);
    };
    return (
        <div className="bg-black  text-white">
            <div>
                <div className="w-full   p-3">
                    <img src={logo} alt="" className='w-[6.578rem] h-[3.75rem] ml-8' />
                </div>
            </div>
            <div className="w-full flex items-center justify-center flex-col mt-[7.625rem]  relative">
                <div>
                    <img src={title} alt="" className="w-[70.3125rem] h-[8.4375rem]" />
                </div>
                <p className="text-lg w-[56.6875rem] text-center mt-[4.75rem]">
                    Gptia is a Web3 AI agent that transforms blockchain data into a dynamic identity and meaningful connections, bridging your on-chain self with real‑world impact.
                </p>
                <div className="w-[591px] mt-[86px] relative z-10 ">
                    <Swiper
                        modules={[Autoplay]}
                        spaceBetween={10}
                        slidesPerView={1}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        loop={true}
                    >
                        <SwiperSlide>
                            <img src={banner1} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={banner2} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={banner3} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={banner4} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={banner5} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={banner6} />
                        </SwiperSlide>
                    </Swiper>
                    <img src={left} alt="" className='w-[14.64rem] h-[16.72rem] absolute left-[-11.25rem] top-0' />
                    <img src={right} alt="" className=' w-[13.26rem] h-[19.02rem] absolute right-[-11.25rem] top-[6.25rem]' />
                </div>
                <img src={bgcircle} alt="" className='absolute bottom-0 left-0 z-0' />
            </div>
            <div className='w-full  flex items-center justify-center mt-[124px]'>
                <div className='w-[81.25rem]'>
                    <div className='w-full flex justify-between items-end'>
                        <div className="text-[4.5rem] font-bold leading-tight">
                            <p>Gptia for On-chain</p>
                            <p>Personality</p>
                        </div>

                        <div className='w-[30rem] h-[10.0625rem]  border border-[#5a5859] rounded-[1.25rem] text-lg text-[#A2A2A2] flex items-center justify-center'>
                            <p className='w-[25rem]'>Generate a dynamic personality card from any wallet address — see behavioral traits visualized in seconds.</p>
                        </div>
                    </div>
                    <div className='w-full h-[38.5625rem] bg-[#896bf6] mt-[7.8125rem] rounded-[2.5rem] flex items-center justify-around hide-scrollbar'>
                        <div>
                            {showSlotMachine ? (
                                <div className='w-[20rem] flex items-center justify-center flex-col'>
                                    {!showTitle ? (<p className='text-[#79FB51] text-2xl text-center font-bold mb-6' style={{ WebkitTextStroke: '1px black' }}>Loading......</p>) : (<p className='text-[#79FB51] text-2xl text-center font-bold mb-6' style={{ WebkitTextStroke: '1px black' }}>Check Complete</p>)}

                                    <div className='w-[10.5rem] h-[10.5rem] overflow-hidden rounded-[1.25rem] border-[0.125rem] border-[#000000]'>
                                        <SlotMachine
                                            ref={myLucky}
                                            prizes={prizes}
                                            slots={slots}
                                            width="10.5rem"
                                            height="10.5rem"
                                            onEnd={endLottery}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className='w-[20rem] flex items-center justify-center flex-col'>
                                    <p
                                        className='w-[9.375rem] text-2xl font-bold text-[#79FB51]'
                                        style={{ WebkitTextStroke: '1px black' }}
                                    >
                                        Check your OnChain Personality
                                    </p>
                                </div>
                            )}

                        </div>
                        <div className={`w-[29.0625rem] h-full  bg-[#e9fee4] text-black`}>
                            {loading ? (
                                <div>
                                    {transactionData.length > 0 && (
                                        <div className="text-black w-full flex items-center justify-center">
                                            <div className="space-y-2 p-2 w-[443px]    mt-2 relative">
                                                <img src={zd} alt="" />
                                                <div className='w-[400px] h-[410px] absolute top-[5rem] left-5  overflow-scroll disscoll' ref={containerRef} >
                                                    <TypewriterText text={JSON.stringify(transactionData, null, 2)} containerRef={containerRef} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            ) : (
                                lotteryFinished ? (
                                    <div className="text-black relative flex items-center justify-center">
                                        <img src={model} alt="" className="w-[24.06rem] h-full" />
                                        <p className="w-[10rem]  absolute top-1 right-[4rem] text-xl font-bold ">{selectedChar.name}</p>
                                        <p className="w-[11.25rem]  absolute top-[3.8rem] text-lg font-bold text-white right-[3.75rem] ">
                                            {selectedChar.title}
                                        </p>
                                        <img src={selectedChar.src} alt="" className="w-[23.95rem] h-[23.95rem] absolute top-[8.1rem] left-[2.55rem]" />
                                        <p className="w-[21.56rem] h-[81px] text-lg absolute bottom-5 left-[3.75rem] text-[1.25rem] font-bold">
                                            {selectedChar.desc}
                                        </p>
                                    </div>
                                ) : (<div className='w-full h-full flex items-center justify-center'>
                                    <img src={que} alt="" />
                                </div>)
                            )}



                        </div>
                        <div>
                            <p className='text-[2.25rem] text-black font-bold w-[26.375rem]'>Enter your web3 wallet address</p>
                            <div className='mt-[3.125rem] w-[27.9375rem] h-[5.5rem]'>
                                <input type="text" className='w-full h-full bg-[#7d5cfb] text-[#4d3591] border-2 border-black rounded-[1.25rem] text-[1.25rem] p-10' placeholder='Web3 wallet address' onChange={(e) => {
                                    setWalletAddress(e.target.value);
                                    setMessage('');
                                }} />
                                <p className='mt-2 ml-2 text-red-500'>{message}</p>
                            </div>
                            <div>
                                <button
                                    className="w-[27.9375rem] h-[5.5rem] border-2 border-black rounded-[1.25rem] bg-[#7ef95c] font-bold text-[1.25rem] mt-[3.125rem] text-black transform transition duration-150 ease-in-out active:scale-95 ${loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-[#7ef95c]'} "
                                    onClick={startLottery}
                                    disabled={loading}
                                >
                                    {loading ? 'Generating...' : 'Generate your web3 personality'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='w-full flex items-center justify-center mt-[11rem]'>
                <div className='w-[81.25rem]'>
                    <div className='w-full flex justify-between items-end'>
                        <div>
                            <p className="text-[4.5rem] font-bold leading-tight">Gptia for Social Influence</p>
                            <p className='text-[#A2A2A2] text-lg mt-[2rem] ml-2'>Automate Twitter engagement effortlessly.</p>
                        </div>
                    </div>
                    <div className='w-full   mt-[7.8125rem]'>
                        {socialInfluences.map((item, index) => (
                            <div key={item.id} className="flex mt-[33px]">
                                <div className="text-[#79FB51] text-[1.5rem] font-bold">
                                    <span className="italic">{String(index + 1).padStart(2, '0')}</span>
                                    <p className="w-[1.375rem] h-[0.1875rem] bg-[#79FB51] mt-[0.03125rem]"></p>
                                </div>
                                <div className="ml-[5.6875rem]">
                                    <p className="text-[1.25rem]">{item.date} <span className="ml-[1.25rem] text-[#8966FA]">{item.address}</span></p>
                                    <p className="text-[1rem] text-[#A2A2A2] mt-[1.25rem]">{item.text}</p>
                                    <p className="w-full h-[0.0625rem] bg-[#2e2c2c] mt-[1.875rem]"></p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="w-full mt-[11rem] flex flex-col items-center">
                <p className="text-[4.5rem] font-bold">Gptia Gallery</p>
                <p className="text-[1.125rem] text-[#A2A2A2] mt-[2.75rem]">See how others use Gptia.</p>
                <div className="w-full mt-[5.8125rem] flex items-center justify-center">
                    <img src={three} alt="" className="w-[77.5rem] h-[79.625rem]" />
                </div>
            </div>

            <div className="w-full mt-[12.5rem] relative">
                <img src={bottom} alt="" />
                <img src={logo} alt="" className="w-[6.25rem] absolute top-[2.5rem] left-[2.5rem]" />

                <a href="https://x.com/GPTia_AI" target="_blank" rel="noopener noreferrer">
                    <div className="absolute top-[3rem] right-[5rem] cursor-pointer transform transition duration-150 ease-in-out active:scale-95">
                        <img src={xlogo} alt="" className="w-[2.88rem]" />
                    </div>
                </a>
            </div>

        </div>
    );
}

export default Aaya;
